<template>
  <div>
    <b v-if="employeeState=='showing'">
      <p class="text-danger" v-if="edited">
        Los cambios no han sido guardados.
        <a href="#" @click.prevent="saveChanges">Guardar.</a>
      </p>
    </b>
    <b-button class="float-right" @click="resetNewSalaries(payrollConfig.id)" v-if="edited == true">Descartar cambios</b-button>
    <b-table
      v-if="salaries.length>0 && (needs_payroll_info||can('view', 'salaries'))"
      :fields="features['imss-installments'] ? salaryFieldsImss: salaryFields"
      :items="salaries"
      :stacked="'md'"
      hover
      striped
    >
      <template #cell(amount)="data">
        <span
          v-if="editingState !== 'updating' || !can('update', 'salaries')"
        >{{ data.item.amount }}</span>
        <b-form-input
          v-if="editingState === 'updating'  && can('update', 'salaries')"
          type="number"
          :value="parseInt(data.item.amount)"
          @input="updateExistingSalary([payrollConfig.id, data.index, 'amount', $event])"
        ></b-form-input>
      </template>
      <template #cell(starting_date)="data">
        <span
          v-if="editingState !== 'updating'  || !can('update', 'salaries')"
        >{{ data.item.starting_date }}</span>
        <b-form-input
          v-if="editingState === 'updating' && can('update', 'salaries')"
          type="date"
          :value="data.item.starting_date"
          @input="updateExistingSalary([payrollConfig.id, data.index, 'starting_date', $event])"
        ></b-form-input>
      </template>
      <template #cell(note)="data">
        <span v-if="editingState !== 'updating' || !can('update', 'salaries')">{{ data.item.note }}</span>
        <b-textarea
          v-if="editingState === 'updating' && can('update', 'salaries')"
          :value="data.item.note"
          :rows="3"
          @input="updateExistingSalary([payrollConfig.id, data.index, 'note', $event])"
        ></b-textarea>
      </template>
      <template #cell(actions)="data">
        <b-button
          size="sm"
          :variant="data.item.deleted ? 'secondary' : 'danger'"
          v-if="editingState =='updating' && can('delete', 'salaries')"
          @click="deleteExistingSalary({ payrollConfigId: payrollConfig.id, salaryIndex: data.index })"
        >{{ data.item.deleted ? 'No eliminar' : 'Eliminar' }}</b-button>
      </template>
    </b-table>
    <!-- b-button variant="success" v-if="state=='show' && (can('create', 'salaries')||needs_payroll_info)" @click="create">Otro salario</b-button-->
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Cantidad (Mensual)">
        <b-form-input type="number" @input="updateSalary(['amount', $event])" :value="amount"></b-form-input>
        <b-form-text>*Campo obligatorio, mayor a 0.</b-form-text>
      </b-form-group>
      <b-form-group v-if="features['imss-installments']" horizontal label="Salario imss (diario)">
        <b-form-input type="number" @input="updateSalary(['tax_amount', $event])" :value="tax_amount"></b-form-input>
        <b-form-text>*Dejar en blanco si el salario mensual es el real.</b-form-text>
      </b-form-group>
      <b-form-group horizontal label="A partir del">
        <b-form-input
          type="date"
          @input="updateSalary(['starting_date', $event])"
          :value="starting_date"
        ></b-form-input>
        <b-form-text>*Campo obligatorio.</b-form-text>
      </b-form-group>
      <b-form-group horizontal label="Nota">
        <b-form-input
          type="text"
          @input="updateSalary(['note', $event])"
          :value="note"
          :state="noteState"
        ></b-form-input>
        <b-form-text>Máximo 1000 caracteres, {{ note.length }} ingresados.</b-form-text>
      </b-form-group>

      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { Validation } from "../../utils";
export default {
  props: {
    payrollConfig: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      salaryFields: [
        {
          key: 'amount',
          label: "Cantidad",
          sortable: true
        },
        {
          key: 'starting_date',
          label: "A partir del",
          sortable: true
        },
        {
          key: 'note',
          label: "Nota"
        },
        {
          key: 'actions',
          label: ""
        }
      ],
      salaryFieldsImss: [
        {
          key: 'amount',
          label: "Cantidad",
          sortable: true
        },
        {
          key: 'starting_date',
          label: "A partir del",
          sortable: true
        },
        {
          key: 'note',
          label: "Nota"
        },
        {
          key: 'tax_amount',
          label: "Salario imss"
        },
        {
          key: 'actions',
          label: ""
        }
      ]
    };
  },
  methods: {
    can: (action, resource) => {
      if (permissions === null) return false;
      if (typeof permissions[resource] === "undefined") return false;
      return permissions[resource].includes(action);
    },
    ...mapActions(["resetNewSalaries", "saveChanges"]),
    ...mapMutations({
      updateSalary: "updateNewSalaryAttribute",
      create: "creatingSalary",
      updateExistingSalary: "updateExistingSalaryAttibute",
      deleteExistingSalary: "deleteExistingSalary"
    }),
    addIfValid() {
      var validation = this.valid();
      if (validation.valid) this.$store.dispatch("addSalary");
      else this.$store.dispatch("displayError", validation.messageBag);
    },
    valid() {
      var validator = new Validation();
      console.log(this.amount);
      validator.rule(this.amount >= 0, "El salario debe ser mayor o igual a 0");
      validator.rule(
        this.starting_date != "",
        "Debe haber una fecha a partir de la cual el empleado tiene ese salario"
      );
      return validator.validate();
    }
  },
  computed: {
    ...mapGetters({
      edited: "salaryEdited"
    }),
    ...mapState({
      employeeState: state => state.employeeManager.state,
      needs_payroll_info: state =>
        state.employeeManager.employee.needs_payroll_info,
      /*salaries: state => {
        return state.employeeManager.employee.salaries.map(salary => {
          return {
            ...salary,
            amount: salary.amount.split(' ')[0].replace(/\,/g, ''),
            currency: salary.amount.split(' ')[1]
          };
        });
      },*/
      state: state => state.employeeManager.salaryState,
      amount: state => state.employeeManager.newSalary.amount,
      tax_amount: state => state.employeeManager.newSalary.tax_amount,
      features: state => state.employeeManager.features,
      starting_date: state => state.employeeManager.newSalary.starting_date,
      note: state => state.employeeManager.newSalary.note,
      editingState: state => state.employeeManager.state
    }),
    noteState() {
      return this.note.length < 1000;
    },
    salaries() {
      return this.payrollConfig.salaries.map(salary => {
        return {
          ...salary,
          amount: salary.amount.split(" ")[0].replace(/\,/g, ""),
          currency: salary.amount.split(" ")[1]
        };
      });
    }
  }
};
</script>
